export function initHtmxLifecycle({ bootstrap, root = document.body }) {
  function initTooltips(scope = document) {
    scope.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((trigger) => {
      bootstrap.Tooltip.getOrCreateInstance(trigger);
      trigger.dataset.tooltipInitialized = "true";
    });
  }

  function disposeTooltips(scope) {
    const triggers = scope.matches?.('[data-bs-toggle="tooltip"]')
      ? [scope]
      : (scope.querySelectorAll?.('[data-bs-toggle="tooltip"]') ?? []);
    triggers.forEach((trigger) =>
      bootstrap.Tooltip.getInstance(trigger)?.dispose(),
    );
  }

  root.addEventListener("htmx:afterSettle", () => {
    initTooltips();
    document
      .querySelectorAll("[data-autohide]:not([data-autohide-registered])")
      .forEach((element) => {
        element.dataset.autohideRegistered = "1";
        if (element.dataset.resetInput) {
          const input = document.querySelector(element.dataset.resetInput);
          if (input) input.value = element.dataset.resetValue ?? "";
        }
        const delay = parseInt(element.dataset.autohide, 10) || 1500;
        setTimeout(() => element.remove(), delay);
      });
  });

  root.addEventListener("htmx:beforeCleanupElement", (event) => {
    disposeTooltips(event.detail.elt);
  });

  return { initTooltips, disposeTooltips };
}
